var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXOpsIntelligenceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 8C9.36267 8 6.376 8 4.52133 9.56267C2.66667 11.1253 2.66667 13.6387 2.66667 18.6667C2.66667 23.6947 2.66667 26.2093 4.52133 27.7707C6.376 29.332 9.36133 29.3333 15.3333 29.3333C21.304 29.3333 24.2907 29.3333 26.1453 27.7707C28 26.208 28 23.6947 28 18.6667C28 17.1067 28 15.7893 27.9453 14.6667",
    stroke: "#0D99FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 2.6665L25.0107 3.59584C25.4613 4.8145 25.6867 5.42384 26.1307 5.86784C26.576 6.31317 27.1853 6.5385 28.404 6.98917L29.3333 7.33317L28.404 7.67717C27.1853 8.12784 26.576 8.35317 26.132 8.79717C25.6867 9.2425 25.4613 9.85184 25.0107 11.0705L24.6667 11.9998L24.3227 11.0705C23.872 9.85184 23.6467 9.2425 23.2027 8.7985C22.7573 8.35317 22.148 8.12784 20.9293 7.67717L20 7.33317L20.9293 6.98917C22.148 6.5385 22.7573 6.31317 23.2013 5.86917C23.6467 5.42384 23.872 4.8145 24.3227 3.59584L24.6667 2.6665Z",
    stroke: "#0D99FF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.333V23.9997M12 15.9997V21.333M8 17.333V19.9997M20 15.9997V21.333M24 17.333V19.9997",
    stroke: "#0D99FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXOpsIntelligenceIcon);
export default __webpack_public_path__ + "static/media/xOPSIntelligenceIcon.22e920c586b4e03d47bb89ada740ae7c.svg";
export { ForwardRef as ReactComponent };